const Footer = ({ fullWidth }) => {
  return (
    <footer
      className="main-footer"
      style={fullWidth ? { marginLeft: 0 } : {}}
    >
      <strong>
        Copyright © 2025{" "}
        {/* <a href="https://app-express.net">App Express Solutions</a>. */}
      </strong>{" "}
      All rights reserved.
    </footer>
  );
};

export default Footer;
